module.exports = __webpack_public_path__ + "assets/media/dataSelectedIcon.21c823a7.svg";